import { FC, useContext, useEffect } from "react";
import ShowPatientInformation from "../addCase/showPatientInformation";
// import ShowPatientAddress from "../addCase/showPatientAddress";
import ShowPrescriberInformation from "../addCase/showPrescriberInformation";
import ShowInsuranceInformation from "../addCase/showInsuranceInformation";
import { CaseStepThreeProps, CaseSummaryProps } from "./types";
import { APIEndpoints } from "src/types/apiTypes";
import useFetch from "src/hooks/useFetch";
import { CaseDoctorIOveraProps } from "src/pages/addCase/types";
// import FacilityInformation from "../facilityInformation";
// import ProviderInformation from "../providerInformation";
import ReferringPrescriberAndProviderInformation from "../referingPrescriberAndPracticeInformation";
import PrescriberInformation from "../prescriberInformation";
import PracticeInformation from "../practiceInformation";
import { AuthContext } from "src/context/authContext";
import { Link } from "react-router-dom";
// import ShowPatientAddress from "../addCase/showPatientAddress";
// import { Controller } from "react-hook-form";

const CaseStepThree: FC<CaseStepThreeProps> = ({ getValues, control }): JSX.Element => {
  const { insurances_attributes, prescription_attributes, doctor_attributes } = getValues();
  const { userData } = useContext(AuthContext)

  const { data: caseSummaryData, mutate: getCaseSummary } =
    useFetch<CaseSummaryProps>(APIEndpoints.FETCH_CASE_SUMMARY, {}, {}, false);


  useEffect(() => {
    if (userData) {
      if (prescription_attributes.drug_name === 'iovera°') {
        const queryParams = {
          ...(["Practice", "Contact", "Organization"].includes(userData.ref_type) && getValues("doctor_attributes.is_anesthesiologist") === true ? 
            {treating_provider_as_practice: {
              practice_id: `${((doctor_attributes as CaseDoctorIOveraProps)?.treating_doctor_id)}`,
            }} : {}
          ),
          treating: {
            practice_id: `${((doctor_attributes as CaseDoctorIOveraProps)?.treating_practice_id)}`,
            ...(getValues("doctor_attributes.is_anesthesiologist") === true ? {} : {
              doctor_id: `${(doctor_attributes as CaseDoctorIOveraProps)?.treating_doctor_id}`
            })
          },
          ...((doctor_attributes as CaseDoctorIOveraProps).referring_practice_id ? {
            referring: {
              practice_id: `${(doctor_attributes as CaseDoctorIOveraProps).referring_practice_id}`,
              doctor_id: `${(doctor_attributes as CaseDoctorIOveraProps).referring_doctor_id}`
            }
          } : {})
        }
        getCaseSummary({}, {}, queryParams)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="">

      <ShowPatientInformation getValues={getValues} />
      {/* <ShowPatientAddress getValues={getValues} /> */}

      <ShowPrescriberInformation getValues={getValues} />

      {caseSummaryData && caseSummaryData.data ?
        <>
          {userData && ["Practice", "Contact", "Organization"].includes(userData.ref_type) ?
            (getValues("doctor_attributes.is_anesthesiologist") === true ?
              <div className="my-4">
                <PracticeInformation practice_information={caseSummaryData.data.treating_provider_as_practice_data} title="Treating Prescriber Information" />
              </div>
              :
              <div className="my-4">
                <PrescriberInformation prescriber_information={caseSummaryData.data.treating_prescriber} title="Treating Prescriber Information" drugName={prescription_attributes.drug_name || ''} />
              </div>
            )
            :
            <div className="my-4">
              <PrescriberInformation prescriber_information={caseSummaryData.data.treating_prescriber} title="Treating Prescriber Information" drugName={prescription_attributes.drug_name || ''} />
            </div>
          }
          <div className="my-4">
            <PracticeInformation practice_information={caseSummaryData.data.treating_practice} title="Treating Facility Information" />
          </div>
          {(doctor_attributes as CaseDoctorIOveraProps).referring_practice_id ? (
            <ReferringPrescriberAndProviderInformation practice_information={caseSummaryData.data.referring_practice} prescriber_information={caseSummaryData.data.referring_prescriber} title={'Referring Prescriber and Facility Information'} />
          ) : null}
        </>
        : null
      }

     

      {insurances_attributes ? insurances_attributes.map((item, index) => (
        <ShowInsuranceInformation 
          key={index} id={index+1} insurance={item}
          drugName={(prescription_attributes && prescription_attributes.drug_name) || ""}
          getValues={getValues}
        />
      )) : null}

      <p className="alert alert-light" role="alert" style={{ backgroundColor: '#fff' }}>
        FlexForward assists healthcare professionals in the determination of whether treatment could be covered by the
        applicable third-party payer based on coverage guidelines provided by the payer and patient information provided
        by the healthcare provider. Third-party reimbursement is affected by many factors. Therefore, FlexForward makes no
        representation or guarantee that full or partial insurance reimbursement or any other payment will be available.
      </p>

      <p className="alert alert-warning rounded-1" role="alert">
        By signing below, I certify that (1) the above therapy is medically necessary and in the best interest of the patient listed above;
        (2) the information provided is complete and accurate to the best of my knowledge; (3) I have obtained any and all authorizations and
        consents from the patient or the patient’s authorized personal representative that are necessary under HIPAA and state law to release
        the patient’s protected health and/or other personal information, including that contained on this form, to Pacira Biosciences, its
        affiliated companies, agents, business partners, contractors, and representatives for purposes relating to the ZILRETTA Copay Assistance
        Program, according to Program Terms and Conditions, and the FlexForward Program, to assist with benefits verification,
        prior authorization/appeals assistance, assess eligibility for copay assistance (as applicable), and forwarding the above
        prescription by fax or other means of delivery to a licensed pharmacy to dispense ZILRETTA where appropriate; [4] I agree to be
        contacted by telephone, email, and/or fax about these programs; and [5] I agree to the Business Associate Agreement as presented at{' '}
        <Link to="/pages/baa" target="_blank" className="text-primary" rel="noreferrer">baa.flexforward.com</Link>
      </p>
    </div>
  );
};

export default CaseStepThree;
